// extracted by mini-css-extract-plugin
module.exports = {"transparentBox":"TransparentBox_style_transparentBox__3HbSu"};